import { render, staticRenderFns } from "./SignInDialogue.vue?vue&type=template&id=20f7dba6&scoped=true"
import script from "./SignInDialogue.vue?vue&type=script&lang=ts"
export * from "./SignInDialogue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7dba6",
  null
  
)

export default component.exports